import { put, call, takeEvery, takeLatest } from 'redux-saga/effects'

import Actions from '../Actions/Creators'
import Types from '../Actions/Types'
import Phi from '../Phi/Phi'
import Constants from '../Phi/Constants'

function* sendMessage(action) {
    yield put(Actions.setLoader())

    const payload = {
        "inFromUser": action.inFromUser,
        "inToUser": action.inToUser,
        "inRefUser": action.inRefUser,
        "inMessage": JSON.stringify(action.inMessage),
        "inType": action.inType
    }
    const response = yield call(Phi.Message.sendMessage, Phi.Message, payload);

    yield put(Actions.fetchMessages(action.inFromUser, action.inToUser, action.inRefUser, 500, 0))
    yield put(Actions.unsetLoader())
}

function* fetchMessages(action){

    yield put(Actions.setLoader())

    const config = {
        "inFromUser": action.inFromUser,
        "inToUser": action.inToUser,
        "inRefUser": action.inRefUser,
        "inLimit": action.inLimit,
        "inOffset": action.inOffset
    }
    const response = yield call(Phi.Message.fetchMessages, Phi.Message, config);

    if(!!!response.error){
        yield put(Actions.storeMessages(action.inFromUser, action.inToUser, action.inRefUser, response, action.inLimit, action.inOffset, null));
    }else {
        yield put(Actions.storeMessages(action.inFromUser, action.inToUser, action.inRefUser, {}, response.inLimit, action.inOffset, response.error));
    }

    yield put(Actions.fetchMessageUnreadCount(action.inFromUser))
    //yield put(Actions.fetchMessageFrom(action.inFromUser, 50, 0))
    yield put(Actions.unsetLoader())

}

function* fetchMessagesFrom(action){

    yield put(Actions.setLoader())

    const config = {
        "inFromUser": action.inFromUser,
        "inLimit": action.inLimit,
        "inOffset": action.inOffset
    }
    const response = yield call(Phi.Message.fetchMessagesFrom, Phi.Message, config);

    if(!!!response.error){
        yield put(Actions.storeMessageFrom(action.inFromUser, action.inLimit, action.inOffset, response, null));
    }else {
        yield put(Actions.storeMessageFrom(action.inFromUser, action.inLimit, action.inOffset, {}, response.error));
        yield put(Actions.unsetLoader())
    }

    // yield put(Actions.unsetLoader())
}

function* fetchMessageReceivers(action){
    
    const config = {
        "inFromUser": action.inFromUser,
        "inLimit": action.inLimit,
        "inOffset": action.inOffset
    }
    const response = yield call(Phi.Message.fetchMessageReceivers, Phi.Message, config);
}

function* fetchMessageUnreadCount(action){
    
    const config = {
        "inFromUser": action.inFromUser
    }
    const response = yield call(Phi.Message.fetchMessageUnreadCount, Phi.Message, config);
    if(!!!response.error){
        yield put(Actions.storeMessageUnreadCount(response));
    }else {
        yield put(Actions.storeMessageUnreadCount(response));
        
    }
}

// Saga Watcher
export function* watchMessageActions() {
    yield* [
        takeEvery(Types.SEND_MESSAGE, sendMessage),
        takeEvery(Types.FETCH_MESSAGES, fetchMessages),
        takeEvery(Types.FETCH_MESSAGE_FROM, fetchMessagesFrom),
        takeEvery(Types.FETCH_MESSAGE_RECEIVERS, fetchMessageReceivers),
        takeEvery(Types.FETCH_MESSAGE_UNREAD_COUNT, fetchMessageUnreadCount)
    ]
}


// WEBPACK FOOTER //
// ./src/Sagas/MessageSaga.js